<template>
  <v-card
    id="ventana"
    tile
    height="100%"
  >
    <v-toolbar
      color="primaryLight"
      dark
      dense
      style="z-index: 2;"
    >
      <v-toolbar-title>Planificación medios aéreos</v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-container
        fluid
        class="pa-0"
      >
        <!-- Primera línea -->
        <v-row
          align="center"
          class="mb-2"
        >
          <!-- Campo rango -->
          <v-col
            cols="12"
            md="6"
          >
            <v-menu
              ref="calendarMenu"
              v-model="calendarMenu"
              :close-on-content-click="false"
              :return-value.sync="rangoFechas"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template
                #activator="{ on, attrs }"
              >
                <v-text-field
                  :value="rangoFechasFormatted"
                  label="Selecciona fecha inicio y fecha fin"
                  prepend-inner-icon="mdi-calendar-range"
                  dense
                  outlined
                  readonly
                  v-bind="attrs"
                  :hide-details="true"
                  v-on="on"
                />
              </template>

              <v-date-picker
                v-model="rangoFechas"
                range
                no-title
                scrollable
              >
                <v-spacer />

                <v-btn
                  text
                  color="primary"
                  @click="calendarMenu = false"
                >
                  Cancel
                </v-btn>

                <v-btn
                  text
                  color="primary"
                  @click="guardarRango()"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <!-- Botones rápidos -->
          <v-col
            cols="12"
            md="auto"
            class="d-flex align-center"
          >
            <v-btn
              color="primary"
              small
              @click="calendarMenu = true"
            >
              <v-icon
                left
                small
              >
                mdi-calendar
              </v-icon>
              Rango
            </v-btn>
            <v-btn
              color="primary"
              outlined
              small
              class="mx-2"
              @click="seleccionarHoy"
            >
              <v-icon
                left
                small
              >
                mdi-clock-outline
              </v-icon>
              Hoy
            </v-btn>
          </v-col>
        </v-row>

        <!-- Toolbar -->
        <v-toolbar
          color="primaryLight"
          dense
          style="z-index: 2"
        >
          <!-- Tabs -->
          <v-tabs
            v-model="tabSelected"
            color="white"
            background-color="primaryLight"
            dark
            slider-color="white"
          >
            <v-tab
              v-for="t in tabs"
              :key="t"
              ripple
            >
              {{ t }}
            </v-tab>
          </v-tabs>
          <!-- Guardar planificación -->
          <v-tooltip>
            <template
              #activator="{ on, attrs }"
            >
              <v-btn
                fab
                x-small
                v-bind="attrs"
                color="secondary"
                bottom
                :disabled="rangoFechas?.length < 2"
                class="mx-2"
                v-on="on"
                @click="showFilterDialog = !showFilterDialog"
              >
                <v-icon
                  color="primary"
                >
                  mdi-filter
                </v-icon>
              </v-btn>
            </template>
            <span>Abrir filtros</span>
          </v-tooltip>
        </v-toolbar>

        <v-tabs-items
          v-model="tabSelected"
        >
          <v-tab-item
            key="Gráfica"
          >
            <v-container
              fluid
              class="pa-0"
            >
              <v-row
                no-gutters
              >
                <v-col
                  cols="12"
                >
                  <v-card
                    flat
                  >
                    <v-card-text>
                      <!-- LEYENDA PARA EL TIMELINE -->
                      <div
                        class="mt-2 legend"
                      >
                        <v-row>
                          <v-col
                            v-for="item in legendItems"
                            :key="item.label"
                            cols="auto"
                            class="d-flex align-center"
                          >
                            <v-icon
                              small
                              :color="item.color"
                            >
                              mdi-circle
                            </v-icon>
                            <span
                              class="ml-1 caption"
                            >{{ item.label }}</span>
                          </v-col>
                        </v-row>
                      </div>

                      <!-- TIMELINE -->
                      <div
                        id="planificacionTimeline"
                      />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </v-card-text>

    <vx-dialog-add-edit-planificacion
      v-if="showDialogAddEdit"
      :show="showDialogAddEdit"
      :id-medio="idMedioSelected"
      :id-planificacion="planificacionSelected"
      :fecha-inicial="rangoFechas[0]"
      @deletePlanificacion="deletePlanificacion"
      @cancelar="handlerAddEditPlanificacion"
      @aceptar="handlerAddEditPlanificacion"
    />
    <vx-dialog-filter-planificacion
      v-if="showFilterDialog"
      :show="showFilterDialog"
      :incendios-filtered="incendiosFiltered"
      :medio-tipos-filtered="medioTiposFiltered"
      @cancelar="showFilterDialog = false"
      @aceptar="aplicarFiltros"
    />
  </v-card>
</template>

<script>
import { Timeline, DataSet } from 'vis-timeline/standalone'
import { mapActions, mapGetters } from 'vuex'
import DialogAddEditPlanificacion from './DialogAddEditPlanificacion.vue'
import { convertDatesToUNIX, formatTimelineFecha, tipoGrupo } from '@/helpers/PlanificacionHelper'
import DateService, { DayjsUnit, FMT, ordenarRangoFechas } from '@/helpers/DateService'
import { orderByCollator } from '@/helpers/Utils'
import { buildDayNightItems } from '@/helpers/planificacion/DayNightItems'
import { legendItems } from '@/helpers/planificacion/LegendItems'
import { createItems } from '@/helpers/planificacion/TimelineHelper'
import DialogFiltrosPlanificacion from './DialogFiltrosPlanificacion.vue'
import { MEDIO_CATEGORIA } from '@/helpers/constants'

export default {
  components: {
    'vx-dialog-add-edit-planificacion': DialogAddEditPlanificacion,
    'vx-dialog-filter-planificacion': DialogFiltrosPlanificacion
  },

  data: () => ({
    // Constantes
    FMT,
    legendItems,
    // Timeline
    rangoFechas: null,
    // Filtros
    showFilterDialog: false,
    incendiosFiltered: null,
    medioTiposFiltered: null,

    calendarMenu: false,

    tabs: ['Gráfica'],
    tabSelected: null,

    headers: [
      { text: '', value: 'data-table-expand' },
      { text: 'Medio', value: 'MEDIO', align: 'left', sortable: false },
      { text: 'Tipo', value: 'TIPO', align: 'left' },
      { text: 'Base.', value: 'BASE', align: 'left' },
      { text: 'Hora de salida', value: 'HORA_SALIDA_BASE', align: 'left' },
      { text: 'Hora llegada inc', value: 'HORA_LLEGADA_INC', align: 'left' },
      { text: 'Hora salida inc', value: 'HORA_SALIDA_INC', align: 'left' },
      { text: 'Hora llegada base', value: 'HORA_LLEGADA_BASE', align: 'left' },
      { text: 'Hora fin descanso', value: 'HORA_FIN_DESCANSO', align: 'left' },
      { text: 'T. máx. vuelo', value: 'TIEMPO_MAX_VUELO', align: 'left' }
    ],
    expandedRows: [],

    mediosAsignados: [],

    planificacionTimeline: null,

    showDialogAddEdit: false,
    isEdit: false,
    editedItem: {},
    medioSelected: null,
    disabledByRol: false,

    mediosPlanificados: [],
    idMedioSelected: null,
    planificacionItems: [],
    planificacionSelected: null
  }),

  computed: {
    ...mapGetters('medio', [
      'tiposMedioAereo', 'medios'
    ]),

    ...mapGetters('usuario', [
      'currentUsuario'
    ]),

    ...mapGetters('incendio', [
      'incendiosReducedFiltered', 'isIncendioFinalizado', 'getIncendioByID'
    ]),

    ...mapGetters('planificacion', ['planificaciones']),

    rangoFechasFormatted() {
      if (!this.rangoFechas || this.rangoFechas.length !== 2) return null

      const [start, end] = this.rangoFechas

      const startFmt = DateService.toDayjs(start, FMT.onlyDateDash).format(FMT.onlyDate)
      const endFmt = DateService.toDayjs(end, FMT.onlyDateDash).format(FMT.onlyDate)
      return `${startFmt} → ${endFmt}`
    },

    mediosFiltrados() {
      let lista = this.medios.filter(medio => medio.ID_MEDIO_CATEGORIA.equalsIgnoreCase(MEDIO_CATEGORIA.AEREO))
      if (this.medioTiposFiltered?.length > 0) {
        lista = lista.filter(medio => this.medioTiposFiltered.includes(medio.ID_MEDIO_TIPO))
      }
      if (this.incendiosFiltered?.length > 0) {
        const idsMediosPlanificados = this.planificacionItems
          .filter(item => this.incendiosFiltered.includes(item.data.ID_INCENDIO))
          .map(p => p.group)

        lista = lista.filter(medio =>
          idsMediosPlanificados.includes(medio.ID_MEDIO)
        )
      }
      // TODO: filtrar por base

      return orderByCollator(lista, 'MEDIO')
    }
  },

  watch: {
    planificaciones: {
      handler(newVal) {
        if (!Array.isArray(newVal)) return
        this.setearData()
      },
      deep: true
    },
    rangoFechas: {
      async handler(newVal) {
        if (newVal?.length < 2) return

        const fechaInicio = newVal[0]
        const fechaFin = newVal.at(-1)

        const inicio = DateService.toDayjs(fechaInicio, FMT.onlyDateDash)
        const fin = DateService.toDayjs(fechaFin, FMT.onlyDateDash)

        if (!inicio.isBefore(fin) && !inicio.isSame(fin)) return

        await this.searchPlanificaciones()
      }
    }
  },

  methods: {
    ...mapActions('planificacion', ['fetchPlanificaciones', 'addPlanificacion', 'editPlanificacion', 'deletePlanificacionById']),

    refreshTimeline() {
      if (!this.planificacionTimeline) return
      this.setearData()
    },

    seleccionarHoy() {
      const currentDay = DateService.getCurrentDayJs().format(FMT.onlyDateDash)
      this.rangoFechas = [currentDay, currentDay]
    },

    guardarRango() {
      this.rangoFechas = ordenarRangoFechas(this.rangoFechas)
      this.$refs.calendarMenu.save(this.rangoFechas)
      this.calendarMenu = false
    },

    // TODO: pensar si pasar al doble click del time line
    onGroupClick(group) {
      this.idMedioSelected = group.data.ID_MEDIO
      this.showDialogAddEdit = true
    },

    async searchPlanificaciones() {
      try {
        await this.fetchPlanificaciones({ fechaInicio: this.rangoFechas[0], fechaFinal: this.rangoFechas.at(-1) })

        if (!this.planificacionTimeline) {
          this.initTimeline()
        } else {
          this.updateTimelineRange()
        }
      } catch (error) {
        console.error(error)
        this.$notify({
          title: 'Error',
          text: 'No se pudieron obtener los datos',
          type: 'error'
        })
      }
    },

    initTimeline() {
      const divTimeline = document.getElementById('planificacionTimeline')
      if (!divTimeline || this.planificacionTimeline) return

      this.planificacionTimeline = new Timeline(
        divTimeline,
        null,
        this.getBaseTimelineOptions()
      )
      this.planificacionTimeline.on('doubleClick', this.onDobleCkickItem)

      this.updateTimelineRange()
      this.setearData()
    },

    onDobleCkickItem(properties) {
      if (!properties.item) return
      const itemSelected = this.planificacionItems.find(x => x.id === properties.item)
      this.planificacionSelected = itemSelected.data.ID_PLANIFICACION_MEDIO
      this.idMedioSelected = itemSelected.group
      if (!this.idMedioSelected || !this.planificacionSelected) return
      this.showDialogAddEdit = true
    },

    setearData() {
      if (!this.planificacionTimeline) return

      this.planificacionTimeline.setGroups(new DataSet(this.getMediosAsGroup()))
      this.planificacionTimeline.setItems(new DataSet(this.setItems()))
    },

    setItems() {
      let items = []

      const [start, end] = this.rangoFechas

      const itemsDiaNoche = buildDayNightItems({
        startDate: start,
        endDate: end
      })

      this.planificacionItems = createItems(this.planificaciones)
      items = [
        ...itemsDiaNoche,
        ...this.planificacionItems
      ]

      items = convertDatesToUNIX(items)
      return items
    },

    getBaseTimelineOptions() {
      return {
        groupOrder: (a, b) => a.order - b.order,

        groupTemplate: group => this.getGroupTemplate(group),

        loadingScreenTemplate() {
          return '<h2>Cargando...</h2>'
        },

        align: 'bottom',
        stack: false,
        stackSubgroups: false,
        showTooltips: true,
        tooltip: {
          followMouse: true,
          overflowMethod: 'cap'
        },
        orientation: 'top',
        zoomMin: 100000,
        verticalScroll: true,
        zoomKey: 'ctrlKey',

        editable: {
          add: false,
          remove: false,
          updateTime: false,
          updateGroup: false,
          overrideItems: false
        }
      }
    },

    updateTimelineRange() {
      if (!this.planificacionTimeline || !this.rangoFechas?.length) return

      const { min, max, start, end } = this.getRangeOptions()

      this.planificacionTimeline.setOptions({ min, max })
      this.planificacionTimeline.setWindow(start, end, { animation: false })
      this.setearData()
    },

    getRangeOptions() {
      const dateInit = DateService.toDayjs(this.rangoFechas[0], FMT.onlyDateDash)
      const dateFinal = DateService.toDayjs(this.rangoFechas.at(-1), FMT.onlyDateDash)

      const min = dateInit.startOf(DayjsUnit.Day).valueOf()
      const max = dateFinal.endOf(DayjsUnit.Day).valueOf()

      return { min, max, start: min, end: max }
    },

    getGroupTemplate(group) {
      if (!group) return

      const container = document.createElement('div')
      container.className = 'group-container'

      // Label principal
      const label = document.createElement('div')
      label.className = 'group-label'
      label.innerHTML = group.content
      container.appendChild(label)

      // Tooltip con info extra
      // if (group.data) {
      //   const tooltip = document.createElement('span')
      //   tooltip.className = 'tooltiptext'
      //   tooltip.innerHTML = `
      //     Base: ${group.data.BASE || '-'}<br>
      //     Tipo: ${group.data.TIPO || '-'}
      //     ${group.data.MODELO ? `| Modelo: ${group.data.MODELO}` : ''}
      //   `
      //   label.appendChild(tooltip)
      // }

      // Click handler del grupo
      if (group.data?.ID_MEDIO) {
        container.addEventListener('click', () => {
          this.onGroupClick(group)
        })
      }

      return container
    },

    aplicarFiltros(filtros) {
      this.incendiosFiltered = filtros.incendiosFiltered
      this.medioTiposFiltered = filtros.medioTiposFiltered
      this.setearData()
      this.showFilterDialog = false
    },

    abrirDialogEdit(item) { // Muestra el panel de edicion de medio / actuacion
      this.isEdit = true
      this.editedItem = Object.assign({}, item)
      this.showDialogAddEdit = true
    },

    getMediosAsGroup() {
      const GRUPOS_GENERALES = { AVIONES: [], HELICOPTEROS: [], MTA: [] }
      const mediosAñadidos = new Set()
      const groups = []

      for (const [i, medio] of this.mediosFiltrados.entries()) {
        const grupoGeneral = tipoGrupo(medio.TIPO)

        // Guardamos el ID_MEDIO en su grupo general
        GRUPOS_GENERALES[grupoGeneral].push(medio.ID_MEDIO)

        if (mediosAñadidos.has(medio.ID_MEDIO)) continue
        mediosAñadidos.add(medio.ID_MEDIO)

        // Guardamos toda la info en 'data' para no tener que buscar después
        groups.push({
          id: medio.ID_MEDIO,
          content: medio.MEDIO,
          order: i + 1,
          className: 'medio',
          data: {
            ID_MEDIO: medio.ID_MEDIO,
            BASE: medio.BASE,
            TIPO: medio.TIPO,
            MODELO: medio.MODELO,
            VELOCIDAD_MAX: medio.VELOCIDAD_MAX,
            TIEMPO_MAX_VUELO: medio.TIEMPO_MAX_VUELO,
            INFRAESTRUCTURA: medio.INFRAESTRUCTURA
          }
        })
      }

      for (const grupo of Object.keys(GRUPOS_GENERALES)) {
        const nested = GRUPOS_GENERALES[grupo]
        if (!nested.length) continue

        groups.push({
          id: grupo,
          content: `<strong>${grupo}</strong>`,
          nestedGroups: nested,
          showNested: true,
          order: 0,
          className: 'grupoGeneral'
        })
      }

      return groups
    },

    closeDialog() {
      this.showDialogAddEdit = false
      this.planificacionSelected = null
      this.idMedioSelected = null
    },

    // Acciones
    async handlerAddEditPlanificacion(data) {
      if (!data) {
        this.closeDialog()
        return
      }
      try {
        if (data.idPlanificacion) {
          await this.editPlanificacion(data)
        } else {
          await this.addPlanificacion(data)
        }
        this.closeDialog()
      } catch (error) {
        console.error('Error al añadir o editar planificacion', error)
        this.$notify({
          title: 'Error',
          text: 'No se puedo gestionar la planificación',
          type: 'error'
        })
      }
    },

    async deletePlanificacion(idPlanificacion) {
      try {
        await this.deletePlanificacionById(idPlanificacion)
        this.closeDialog()
      } catch (error) {
        console.error('Error al eliminar la planificación', error)
        this.$notify({
          title: 'Error',
          text: 'No se puede eliminar la planificación',
          type: 'error'
        })
      }
    }
  }
}
</script>

<style scoped>
  @import '../../../node_modules/vis-timeline/dist/vis-timeline-graph2d.min.css';

  ::v-deep .v-window__container,
  ::v-deep .v-window-item {
    height: calc(100vh - 260px);
  }

  ::v-deep .vis-labelset .vis-label .vis-inner {
    /* width: 100%; */
    max-width: 350px;
    padding: 5px;
  }

  /* Texto demasiado grande */
  ::v-deep .group {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* TODO: pensar como unificar estas clases con la leyenda del timeline */
  ::v-deep .vis-item.transito  { background-color: #FFC400; }
  ::v-deep .vis-item.incendio  { background-color: #FF0000; }
  ::v-deep .vis-item.descanso { background-color: #FFFF00; }
  ::v-deep .vis-item.demora { background-color: #00AABB; }
  ::v-deep .vis-item.background-dia { background-color: rgba(170, 255, 248, 0.541); }
  ::v-deep .vis-item.background-noche { background-color: rgba(235, 170, 255, 0.329); }

  /* Tooltip */
  ::v-deep .group .tooltiptext {
    position: absolute;
    top: 10px;
    right: 30px;
    font-size: 12px !important;
    text-align: left!important;
    visibility: hidden;
    padding: 5px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    z-index: 1;
  }

  ::v-deep .group:hover .tooltiptext {
    visibility: visible;
    position: absolute;
  }

  /* Boton */
  ::v-deep .fabBtn {
    float: left;
    background: #00759e;
    background-color: #00759e;
    width: 24px;
    height: 24px;
    margin-right: 6px;
    border-radius: 100%;
    border: none;
    outline: none;
    color: #FFF;
    font-size: medium;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    transition: .3s;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  ::v-deep .fabBtn:focus {
    transform: scale(1.1);
    transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }

  ::v-deep .fabBtn:disabled {
    background-color: #9e2000;
  }

  ::v-deep .v-window {
    overflow: auto;
  }

  ::v-deep .grupoGeneral {
    background-color: #00759e;
    color: white;
  }
  .legend {
  background-color: white;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

::v-deep .group-label {
  position: relative;
  padding: 4px 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
}

::v-deep .group-label:hover {
  background-color: rgba(0, 123, 255, 0.1); /* azul claro al pasar el ratón */
}

::v-deep .tooltiptext {
  visibility: hidden;
  background-color: #333;
  color: #fff;
  text-align: left;
  padding: 6px 8px;
  border-radius: 4px;
  position: absolute;
  z-index: 10;
  top: 100%;
  left: 0;
  white-space: nowrap;
}

::v-deep .group-label:hover .tooltiptext {
  visibility: visible;
}

</style>
